import React, { useEffect, useState } from 'react';
import WizardForApprove from './WizardForApprove';
import AgreementPrivacy from './AgreementPrivacy';
import { WizardForApproveStep, Agreement } from '../types';
import AgreementTerms from './AgreementTerms';

export default function(props: {
  text: string;
  steps: WizardForApproveStep[];
  agreementsUnsigned: Agreement[]; // agreements that needed to confirm
}) {
  const [agreementsSigned, setAgreementsSigned] = useState<Agreement[]>([]);
  const [activeStep, setActiveStep] = useState(0);

  /**
   * Init from props and localStorage.
   */
  useEffect(() => {
    const store = window.localStorage.getItem('UPAgreements');
    const agreements: Agreement[] = ['privacy_policy_v1', 'terms_of_use_v1'];
    const agreementsSignedStore: Agreement[] = store ? JSON.parse(store) : [];
    const agreementsSignedDiff = agreements.filter(agreement => {
      return (
        props.agreementsUnsigned.indexOf(agreement) !== -1 &&
        agreementsSignedStore.indexOf(agreement) !== -1
      );
    });
    setAgreementsSigned(agreementsSignedDiff);
    setActiveStep(agreementsSignedDiff.length);
  }, [props.agreementsUnsigned]);

  function handleCheckedPrivacy(checked: boolean) {
    if (checked) {
      addAgreement('privacy_policy_v1');
    } else {
      removeAgreement('privacy_policy_v1');
    }
  }

  function handleCheckedTerms(checked: boolean) {
    if (checked) {
      addAgreement('terms_of_use_v1');
    } else {
      removeAgreement('terms_of_use_v1');
    }
  }

  function addAgreement(agreement: Agreement) {
    setAgreementsSigned(agreements => {
      const result: Agreement[] = [...agreements];
      if (agreements.indexOf(agreement) === -1) {
        result.push(agreement);
      }
      window.localStorage.setItem('UPAgreements', JSON.stringify(result));
      return result;
    });
  }

  function hasAgreement(agreement: Agreement) {
    return agreementsSigned.indexOf(agreement) !== -1;
  }

  function removeAgreement(agreement: Agreement) {
    setAgreementsSigned(agreements => {
      const result: Agreement[] = [...agreements];
      const index = agreements.indexOf(agreement);
      if (index !== -1) {
        result.splice(index, 1);
      }
      window.localStorage.setItem('UPAgreements', JSON.stringify(result));
      return result;
    });
  }

  const steps: WizardForApproveStep[] = [
    {
      content: (
        <AgreementPrivacy
          onChange={handleCheckedPrivacy}
          value={hasAgreement('privacy_policy_v1')}
        />
      ),
      isNextDisabled() {
        return !hasAgreement('privacy_policy_v1');
      }
    },
    {
      content: (
        <AgreementTerms
          onChange={handleCheckedTerms}
          value={hasAgreement('terms_of_use_v1')}
        />
      ),
      isNextDisabled() {
        return !hasAgreement('terms_of_use_v1');
      }
    }
  ];
  return (
    <WizardForApprove
      text={props.text}
      steps={steps.concat(props.steps)}
      activeStep={activeStep}
    />
  );
}
